<template>
  <div class="results-pdf-filter width-responsiveness">
    <card-form :collapsed="true">
      <div
        slot="expanded"
        class="form-container"
      >
        <md-layout
          :md-gutter="24"
          md-flex="100"
          style="gap: 20px 0"
        >
          <md-layout
            md-flex="100"
            md-flex-medium="100"
          >
            <h2 class="orders-new__doctor__title title-main">Buscar Laudo(s)</h2>
          </md-layout>

          <md-layout
            md-flex="30"
            md-flex-medium="50"
          >
            <SearchFieldSelector
              :default-start-date="defaultStartDate"
              :default-end-date="defaultEndDate"
              :options="dateSelectOptions"
              :clean-date="cleanDate"
              @updateSearchValue="handleSearchValueUpdate"
            />
          </md-layout>

          <md-layout
            md-flex="35"
            md-flex-medium="50"
          >
            <SearchFieldSelector
              :options="searchOptions"
              @updateSearchValue="handleSearchValueUpdate"
              @enterPressed="getResultsByFilter"
            />
          </md-layout>

          <md-layout
            md-flex="25"
            md-flex-medium="50"
          >
            <div class="results-pdf-filter__radio">
              <md-radio
                v-model="filter.examFilter"
                md-value="ALL"
              >
                <md-tooltip
                  md-delay="100"
                  md-direction="top"
                >
                  Todos lidos/Não lidos
                </md-tooltip>
                Todos
              </md-radio>
              <md-radio
                v-model="filter.examFilter"
                md-value="NOT_READED"
              >
                <md-tooltip
                  md-delay="100"
                  md-direction="top"
                >
                  Exames não lidos
                </md-tooltip>
                Não lidos
              </md-radio>
              <md-radio
                v-model="filter.examFilter"
                md-value="READED"
              >
                <md-tooltip
                  md-delay="100"
                  md-direction="top"
                >
                  Exames lidos
                </md-tooltip>
                Lidos
              </md-radio>
            </div>
          </md-layout>

          <md-layout
            md-flex="10"
            md-flex-medium="50"
            class="box-action"
          >
            <button
              :disabled="resultsPdfLoadingStatus"
              class="btn btn-primary btn-search"
              @click="getResultsByFilter"
            >
              <md-icon
                md-src="/static/images/icon-search.svg"
                class="icon-search"
              >
                search
              </md-icon>
              Buscar
            </button>
          </md-layout>
        </md-layout>
      </div>
    </card-form>

    <div class="results-pdf-filter__tabs">
      <FakeTab
        :first-active="firstTabSelected"
        first-title="Todos"
        secound-title="Completo"
        @update="fakeTabUpdate"
      />
    </div>
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import DatePickerRange from '@/components/common/DatePickerRange'
import DatePicker from '@/components/common/DatePicker'
import SearchFieldSelector from '@/components/common/SearchFieldSelector'
import FakeTab from '@/components/common/FakeTab'

import Moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { formartDateFromArray } from '@/utils/date-utils'
import { LAUDO_PDF_PERIOD_DAYS_DEFAULT } from '@/enums'
import notify from '@/api/notification'

export default {
  components: {
    CardForm,
    DatePickerRange,
    DatePicker,
    SearchFieldSelector,
    FakeTab,
  },
  data() {
    return {
      filter: {
        alvaroId: '',
        lisId: '',
        namePatient: '',
        examFilter: 'ALL',
        osWithAllExamsFinished: false,
        byResultDate: false,
        mnemonic: '',
      },
      date: {
        start: '',
        end: '',
      },
      singleDate: '',
      limitDays: 1827,
      maxDate: new Date(),
      dateSelectOptions: [
        {
          value: 'date',
          label: 'Data de Cadastro',
          placeholder: 'Data de Cadastro',
          limitDays: 1827,
          singleDate: false,
          selected: true,
          type: 'date',
          propName: 'date',
        },
        {
          value: 'singleDate',
          label: 'Data de Resultado',
          placeholder: 'Data de Resultado',
          limitDays: 1827,
          singleDate: false,
          selected: false,
          type: 'singleDate',
          propName: 'date',
        },
      ],
      searchOptions: [
        {
          value: 'namePatient',
          label: 'Nome do Paciente',
          placeholder: 'Nome do paciente + Enter para buscar',
          limitDays: null,
          singleDate: false,
          selected: false,
          propName: 'namePatient',
        },
        {
          value: 'alvaroId',
          label: 'O.S. Álvaro',
          placeholder: 'O.S. Álvaro + Enter para buscar',
          limitDays: null,
          singleDate: false,
          selected: false,
          propName: 'alvaroId',
        },
        {
          value: 'lisId',
          label: 'O.S. Lis',
          placeholder: 'O.S. Lis + Enter para buscar',
          limitDays: null,
          singleDate: false,
          selected: false,
          propName: 'lisId',
        },
        {
          value: 'mnemonic',
          label: 'Exame',
          placeholder: 'Mnemônico do exame + Enter para buscar',
          limitDays: null,
          singleDate: false,
          selected: false,
          propName: 'mnemonic',
        },
      ],
      currentTab: 'todos',
      cleanDate: 0,
    }
  },
  computed: {
    ...mapGetters(['getTodayDate', 'resultsPdfLoadingStatus']),
    today: function () {
      return Moment(new Date()).format('DD/MM/YYYY')
    },
    defaultStartDate: function () {
      return Moment(this.today, 'DD/MM/YYYY')
        .subtract(LAUDO_PDF_PERIOD_DAYS_DEFAULT, 'days')
        .format('DD/MM/YYYY')
    },
    defaultEndDate: function () {
      return this.today
    },
    limitData: function () {
      let today = formartDateFromArray(this.getTodayDate)
      return Moment(today, 'DD/MM/YYYY').subtract(this.limitDays, 'days').toDate()
    },
    firstTabSelected() {
      return this.currentTab === 'todos'
    },
  },
  beforeDestroy() {
    this.clearFilters()
  },
  methods: {
    ...mapActions(['getServiceResultsPDF', 'getResultsPDFFilter']),
    getResultsByFilter() {
      this.filter['page'] = 1

      this.getResultsPDFFilter(this.filter)
      this.getServiceResultsPDF()
    },
    clearFilters() {
      for (let chave in this.filter) {
        delete this.filter[chave]
      }
    },
    handleSearchValueUpdate(value) {
      if (value.type === 'date') {
        this.filter.byResultDate = false
        this.filter['transferDateFrom'] = this.defaultStartDate
        this.filter['transferDateTo'] = this.today

        if (this.isRangeValid(value.date)) {
          this.filter['transferDateFrom'] =
            value.date && value.date.start !== ''
              ? Moment(value.date.start).format('DD/MM/YYYY')
              : ''
          this.filter['transferDateTo'] =
            value.date && value.date.end !== ''
              ? Moment(value.date.end).format('DD/MM/YYYY')
              : ''
        } else {
          this.cleanDate++
          this.filter['transferDateFrom'] = this.today
          this.filter['transferDateTo'] = this.today

          notify({
            title: 'AVISO:',
            message: 'Selecione um período de até 4 meses.',
          })
        }
      } else if (value.type === 'singleDate') {
        this.filter.byResultDate = true
        this.filter['transferDateFrom'] =
          value.singleDate !== '' ? Moment(value.singleDate).format('DD/MM/YYYY') : ''
        this.filter['transferDateTo'] =
          value.singleDate !== '' ? Moment(value.singleDate).format('DD/MM/YYYY') : ''
      } else {
        this.filter.namePatient = ''
        this.filter.alvaroId = ''
        this.filter.lisId = ''
        this.filter.mnemonic = ''
        this.filter[value.propName] = value.query
      }
    },
    fakeTabUpdate(val) {
      if (val) {
        this.currentTab = 'todos'
        this.filter.osWithAllExamsFinished = false
        this.getResultsByFilter()
      } else {
        this.currentTab = 'completo'
        this.filter.osWithAllExamsFinished = true
        this.getResultsByFilter()
      }
    },
    isRangeValid(date) {
      if (!date || !date.start || !date.end) return false
      const startDate = Moment(date.start).startOf('day')
      const endDate = Moment(date.end).startOf('day')
      return startDate.isValid() && endDate.isValid() &&
        !endDate.isBefore(startDate) &&
        !endDate.isAfter(startDate.clone().add(4, 'months'))
    },
  },
}
</script>

<style lang="scss">
.results-pdf-filter {
  margin-top: 25px;
  font-family: 'Exo 2', sans-serif !important;

  .card-form__container {
    border-radius: 8px;
    padding-bottom: 18px;

    .date-picker {
      .search-bar__date {
        margin: 0;
      }

      label {
        pointer-events: auto;
        top: 0;
        opacity: 1;
        font-size: 12px;
      }

      #datePickerSelect {
        margin: 0;
        padding-top: 10px;
        min-height: inherit;
      }

      #datePickerSingleSelect {
        margin: 0;
        padding-top: 10px;
        min-height: inherit;
      }
    }

    .box-action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-left: 0;
    }

    .btn-search {
      width: 100%;
      max-width: 130px;
      text-transform: uppercase;
      font-family: 'Exo 2', sans-serif !important;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 4px;
      font-size: 14px;
      gap: 4px;

      .md-icon {
        margin: 0;
      }
    }
  }

  &__checkbox {
    &.md-theme-default.md-checkbox.md-checked .md-checkbox-container {
      background-color: #7f1a54;
      border-color: #7f1a54;
    }
  }

  &__radio {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 350px;
    justify-content: space-between;

    &--flex-start {
      justify-content: flex-start;
      align-items: flex-start;

      .md-radio {
        margin: 16px 50px 16px 0;
      }
    }

    .md-theme-default.md-radio .md-radio-container:after {
      background-color: #7f1a54;
    }

    .md-theme-default.md-radio.md-checked .md-radio-container {
      border-color: #7f1a54;
    }
  }

  &__tabs {
    margin-top: 40px;

    .fake-tab {
      margin-bottom: 0;
    }
  }
}
</style>
